(() => {
  if (customElements.get('teabo-calendar-popup')) return;

  class TeaboCalendarPopup extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.storageKey = 'teabo-calendar-popup-2026';
      this.preview = new URLSearchParams(window.location.search).get('teabo_popup') === 'preview';
      this.attempts = 0;
      const options = { signal: this.controller.signal };

      this.querySelectorAll('[data-calendar-close]').forEach(button => {
        button.addEventListener('click', () => this.dialog.close(), options);
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('a[href], button:not([disabled])')];
        const firstControl = controls[0];
        const lastControl = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === firstControl) {
          event.preventDefault();
          lastControl.focus();
        } else if (!event.shiftKey && document.activeElement === lastControl) {
          event.preventDefault();
          firstControl.focus();
        }
      }, options);
      document.addEventListener('shopify:section:select', event => {
        if (event.detail.sectionId === this.dataset.sectionId) this.open(true);
      }, options);

      if (this.preview) {
        this.timer = window.setTimeout(() => this.open(true), 250);
      } else if (this.dataset.enabled === 'true' && !window.Shopify?.designMode && this.eligible()) {
        this.timer = window.setTimeout(() => this.open(false), Number(this.dataset.delay) * 1000);
      }
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
    }

    eligible() {
      if (this.dataset.end) {
        const deadline = Date.parse(this.dataset.end);
        if (!Number.isFinite(deadline) || Date.now() >= deadline) return false;
      }
      try {
        const lastShown = Number(window.localStorage.getItem(this.storageKey));
        const interval = Number(this.dataset.days) * 86400000;
        return !lastShown || Date.now() - lastShown >= interval;
      } catch {
        return false;
      }
    }

    busy() {
      if (document.visibilityState !== 'visible') return true;
      // Le consentement doit rester accessible avant toute fenêtre promotionnelle.
      const consentBanner = document.getElementById('shopify-pc__banner');
      if (consentBanner && consentBanner.getClientRects().length) return true;
      if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return true;
      if (document.querySelector('#CartDrawer.is-open, .v5loc.est-visible')) return true;
      return [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')].some(element => {
        if (element === this.dialog) return false;
        const bounds = element.getBoundingClientRect();
        const style = window.getComputedStyle(element);
        return style.visibility !== 'hidden' && style.display !== 'none' && style.opacity !== '0' && bounds.width > 0 && bounds.height > 0 && bounds.right > 0 && bounds.left < window.innerWidth;
      });
    }

    open(manual) {
      if (this.dialog.open || (!manual && !this.eligible())) return;
      if (this.busy()) {
        this.attempts += 1;
        if (this.attempts < 6) this.timer = window.setTimeout(() => this.open(manual), 2000);
        return;
      }
      if (!manual) {
        try {
          window.localStorage.setItem(this.storageKey, String(Date.now()));
        } catch {
          return;
        }
      }
      this.previousFocus = document.activeElement;
      this.dialog.showModal();
    }
  }

  customElements.define('teabo-calendar-popup', TeaboCalendarPopup);
})();
